export default "__VITE_ASSET__BNCq84hZ__"